// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cv-item[data-v-beb991fc]{background-color:#fff;border:1px solid #dcdfe6;display:flex;justify-content:space-between;margin-top:10px;padding:20px}.cv-item .title[data-v-beb991fc]{color:#303133;font-size:16px}.cv-item .type[data-v-beb991fc]{color:#909399;font-size:14px;margin-left:10px}.cv-item .checker[data-v-beb991fc]{color:#f2533d}.cv-item[data-v-beb991fc]:hover{background-color:#fafafa;cursor:pointer}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
